import { MinzeElement } from 'minze'

export interface LvcWarningIcon {}

export class LvcWarningIcon extends MinzeElement {
  html =
    () => `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.948 2.57554C11.4155 1.80815 12.5845 1.80815 13.052 2.57554L23.8354 20.2734C24.303 21.0408 23.7185 22 22.7834 22H1.2166C0.281453 22 -0.303009 21.0408 0.164564 20.2734L10.948 2.57554Z" fill="#FF4600"/>
  <path d="M10.9382 10.1833V7H13.0792V10.1833L12.5439 15.0167H11.4562L10.9382 10.1833ZM12.0087 19C11.6518 19 11.3583 18.8944 11.1281 18.6833C10.9094 18.4722 10.8 18.2 10.8 17.8667C10.8 17.5333 10.9094 17.2611 11.1281 17.05C11.3583 16.8389 11.6518 16.7333 12.0087 16.7333C12.354 16.7333 12.636 16.8389 12.8547 17.05C13.0849 17.2611 13.2 17.5333 13.2 17.8667C13.2 18.2 13.0849 18.4722 12.8547 18.6833C12.636 18.8944 12.354 19 12.0087 19Z" fill="white"/>
  </svg>`
}
